const ProgressType = Object.freeze({
  O: "Ongoing",
  C: "Completed",
  L: "Lapsed",
});

export default ProgressType;
